module.exports = __webpack_public_path__ + "static/media/Pasos_Fondo1.3eeacc12.png";